import React, { useRef, useState } from "react";
import { useSpring, animated } from "@react-spring/web";
import useMeasure from "react-use-measure";
import classNames from "classnames";

// Constants
import ArrowDown from "assets/icons/arrowDown.svg?react";
import { INVITE_RULES } from "../../../constants/invite";

// Components
import InviteFriendRulesItem from "../InviteFriendRulesItem";

// Hooks
import useTranslate from "../../../hooks/useTranslate";
import useClickOutside from "../../../hooks/useClickOutside";
import { useGTM } from "../../../hooks/useGTM";
import { useBreakpoint } from "../../../hooks/useBreakpoint";

// Icons

import "./styles.sass";

const InviteFriendRules = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [contentRef, bounds] = useMeasure();
  const t = useTranslate();
  const GTM = useGTM();
  const path = window.location.href;
  const { isDesktop } = useBreakpoint();
  const accordionRef = useRef(null);

  const expand = useSpring({
    height: isOpen ? bounds.height : 0,
    opacity: isOpen ? 1 : 0,
    overflow: "hidden",
  });

  const parentClass = classNames("InviteFriendRules", { active: isOpen });
  const btnClass = classNames("InviteFriendRules__btn", { active: isOpen });
  const arrowClass = classNames("InviteFriendRules__arrow", { active: isOpen });

  const open = () => {
    GTM.clickRulesInviteFriend(path);
    setIsOpen(true);
  };

  const close = () => {
    setTimeout(() => {
      setIsOpen(false);
    }, 350);
  };

  const handleClick = () => {
    if (isOpen) {
      close();
    } else {
      open();
    }
  };

  useClickOutside({
    refs: [accordionRef],
    handler: close,
    isDisable: !isDesktop,
  });

  return (
    <div className={parentClass} ref={accordionRef}>
      {/* eslint-disable-next-line react/button-has-type */}
      <button className={btnClass} onClick={handleClick}>
        <span className="InviteFriendRules__title">
          {t("referral.rules.title")}
        </span>
        <div className={arrowClass}>
          <ArrowDown />
        </div>
      </button>

      <animated.div style={expand} className="InviteFriendRules__content">
        <div ref={contentRef}>
          {INVITE_RULES.map((rule) => (
            <InviteFriendRulesItem key={rule.id} rule={rule} />
          ))}
        </div>
      </animated.div>
    </div>
  );
};

export default InviteFriendRules;
